import {createAsyncThunk, createEntityAdapter, createSelector, createSlice} from "@reduxjs/toolkit";
import {facilitiesKey} from "./entities";
import {callGraphQL} from "./api.slice";

export const fetchFacility = createAsyncThunk(`${facilitiesKey}/fetchFacility`, async ({facilityId}, context) => {
    const request = {
        query: `query getFacility($facilityId: Int!) { 
            getFacility(facility_id: $facilityId) { 
                id,
                address,
                facility_name,
                timezone,
                tenants
            } 
        }`,
        variables: {facilityId},
        isPublic: true,
        response: {getFacility: facilitiesKey}
    }
    const result = await context.dispatch(callGraphQL(request));
    if (result.type.endsWith('rejected')) {
        return context.rejectWithValue(result.payload ? result.payload : result.error);
    } else {
        return result;
    }
});

const adapter = createEntityAdapter({selectId: f => f.uid});
const slice = createSlice({
    name: facilitiesKey,
    initialState: adapter.getInitialState({loading: false, errors: null}),
    reducers: {},
    extraReducers: {
        [fetchFacility.pending]: (state) => {
            state.errors = null;
            state.loading = true;
        },
        [fetchFacility.rejected]: (state, {payload}) => {
            state.errors = payload;
            state.loading = false;
        },
        [fetchFacility.fulfilled]: (state) => {
            state.errors = null;
            state.loading = false;
        },
        [callGraphQL.fulfilled]: (state, {payload}) => {
            if (payload[facilitiesKey]) adapter.upsertMany(state, payload[facilitiesKey]);
        }
    }
})
export default slice.reducer;
export const selectFacilities = state => state[facilitiesKey];
export const {
    selectById: selectFacilityById,
    selectIds: selectFacilityIds,
    selectEntities: selectFacilityEntities,
    selectAll: selectAllFacilities,
    selectTotal: selectTotalFacilities
} = adapter.getSelectors(selectFacilities)
export const isFetchFacilityLoading = () => createSelector(
    selectFacilities,
    (state) => !!state.loading
)
export const getFetchFacilityErrors = () => createSelector(
    selectFacilities,
    (state) => state.errors ? state.errors : []
)
export const facilityById = () => createSelector(
    (state) => state,
    (_, facilityId) => facilityId,
    selectFacilityById
)
export const facilityInfo = (id) => state => {
    console.trace();
    return id ? selectFacilityById(state, id) : null;
}
